import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody } from "reactstrap";

const ConfirmAccount = ({ pageTitle, children }) => {
  return (
    <>
      <h1 className="pageTitle">{pageTitle}</h1>
      <Card className="mx-auto" style={{ maxWidth: "700px" }}>
        <CardBody>
          {children}
        </CardBody>
      </Card>
    </>
  );
};

ConfirmAccount.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  children: PropTypes.node
};

ConfirmAccount.defaultProps = {
  children: null
};

export default ConfirmAccount;
